export function getLowQualityImg(
  imageUrl: string,
  imageQuality: number = 4096
) {
  const allowedQualities = [1080, 1920, 4096];
  let urlWithQuality = imageUrl;

  if (imageUrl.includes("uploads") && allowedQualities.includes(imageQuality)) {
    urlWithQuality = imageUrl.replace("uploads", String(imageQuality));
  }

  //check if image url includes any allowed qualities

  allowedQualities.forEach((allowedQuality) => {
    if (imageUrl.includes(`/${allowedQuality}/`)) {
      urlWithQuality = imageUrl.replace(
        `/${allowedQuality}/`,
        `/${imageQuality}/`
      );
    }
  });

  return urlWithQuality;
}
